<template>
    <v-navigation-drawer app v-model="drawerModel" clipped class="d-print-none mobile-mt" v-if="$store.isExpire()">
        <v-list nav dense>
            <template v-for="nav_list in nav_lists">
                <v-list-item v-if="!nav_list.lists" :to="nav_list.link" :key="nav_list.name">
                    <v-list-item-content>
                        <v-list-item-title>
                            {{ nav_list.name }}
                        </v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                <v-list-group v-else no-action :key="nav_list.name" v-model="nav_list.active">
                    <template v-slot:activator>
                        <v-list-item-content>
                            <v-list-item-title>
                                {{ nav_list.name }}
                            </v-list-item-title>
                        </v-list-item-content>
                    </template>
                    <v-list-item v-for="list in nav_list.lists" :key="list.name" :to="list.link">
                        <v-list-item-title>
                            {{ list.name }}
                        </v-list-item-title>
                    </v-list-item>
                </v-list-group>
            </template>
        </v-list>
    </v-navigation-drawer>
</template>

<script>
import ACCOUNT from "@/consts/account.js";
import moment from "moment";

export default {
    name: "sidemenu",
    props: [
        "drawer"
    ],
    computed: {
        drawerModel: {
            get() {
                return this.drawer;
            },
            set(val) {
                this.$emit('input', val);
            }
        }
    },
    data: function () {
        const menues = {
            nav_lists: [],
        };
        const self = this.$store.state.user;

        menues.nav_lists.push({
            name: "TOP",
            link: "/",
        });
        menues.nav_lists.push({
            name: "見合台帳",
            link: `/matching-ledger?date=${moment().format('YYYY-MM-DD')}`,
        });
        menues.nav_lists.push({
            name: "会員管理",
            link: "",
            active: false,
            lists: [
                {
                    name: "会員一覧",
                    link: "/customer/list",
                },
                {
                    name: "担当一覧",
                    link: "/customer/staff",
                }
            ],
        });
        menues.nav_lists.push({
            name: "見合管理",
            link: "",
            active: false,
            lists: [
                {
                    name: "お見合チェック",
                    link: "/matching-check",
                },
                {
                    name: "見合状況一覧",
                    link: "/matching-status",
                }
            ],
        });
        menues.nav_lists.push({
            name: "一覧表示",
            link: "",
            active: false,
            lists: [
                {
                    name: "予定一覧",
                    link: "/reservation",
                },
                {
                    name: "ＴＥＬ一覧",
                    link: "/tel",
                },
                {
                    name: "見合入金一覧",
                    link: "/matching_pay",
                },
                {
                    name: "会員フォロー状況リスト",
                    link: "/following_status/list",
                },

            ],
        })
        menues.nav_lists.push({
            name: "会員数状況",
            link: "",
            active: false,
            lists: [
                {
                    name: "支店別",
                    link: "/customer_count/shop",
                },
                {
                    name: "担当CO別",
                    link: "/customer_count/co",
                },
            ],
        })
        menues.nav_lists.push({
            name: "絶対表",
            link: "/customer_shift/month",
        });
        if ((self.privilege & ACCOUNT.PRIVILEGE.VAL.SYSTEM_ADMIN) ||
            (self.privilege & ACCOUNT.PRIVILEGE.VAL.ALERT_ALL) ||
            (self.privilege & ACCOUNT.PRIVILEGE.VAL.ALERT_SHOP_ALL) ||
            (self.privilege & ACCOUNT.PRIVILEGE.VAL.ALERT_OWN)) {
            menues.nav_lists.push({
                name: "アラート",
                link: "/alert",
            });
        }
        if ((self.privilege & ACCOUNT.PRIVILEGE.VAL.SYSTEM_ADMIN) ||
            (self.privilege & ACCOUNT.PRIVILEGE.VAL.ACCOUNT_EDIT) ||
            (self.privilege & ACCOUNT.PRIVILEGE.VAL.ACCOUNT_DELETE)) {
            menues.nav_lists.push({
                name: "アカウント管理",
                link: "/account",
            });
        }
        return menues;
    }
};
</script>

<style lang="css" scoped>
@media only screen and (max-width: 1264px) {
    .mobile-mt {
        margin-top: 64px;
    }
}
</style>